export default "__VITE_ASSET__DTeqV_8f__"